"use client";

import { Heading } from "@/components/ui/typography";

export default function NonQualificationSection({ heading = "What does NOT qualify for offshore profits treatment" }: { heading?: string } = {}) {
  return (
    <section className="bg-black py-[60px] px-4 lg:px-[120px] flex justify-center">

      <div className="w-full max-w-[1200px] flex flex-col items-center lg:flex-row gap-10 lg:gap-[32px]">

        {/* HEADING */}
        <div className="flex-1">
          <Heading as="h2" variant="section">
            {heading}
          </Heading>
        </div>

        {/* CARD */}
        <div className="flex-1">
          <div className="bg-[#0f1218] border border-white/10 rounded-[12px] p-6 sm:p-8 lg:p-[48px]">
            <p className="text-white/70 text-[14px] leading-[160%] font-medium">
              Not every company qualifies. Examples that may remain taxable:
              companies serving Hong Kong customers, companies with offices in
              Hong Kong, companies employing Hong Kong staff, and retail
              businesses operating locally. This is why structure design matters
              before incorporation begins.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}